export default "__VITE_ASSET__e389a8cb__"